import { ArrowRight } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { REGISTER_URL, LOGIN_URL } from '../lib/links';

export function Cta() {
  return (
    <section className="section">
      <div className="container">
        <Reveal>
          <div className="cta-banner">
            <h2>
              Your success is <span style={{ color: 'var(--gold)' }}>our mission.</span>
            </h2>
            <p>
              Join a global community building a decentralized future — activate your account and
              start earning across the full Alpha One compensation plan.
            </p>
            <div className="hero-cta">
              <a href={REGISTER_URL} className="btn btn-gold btn-lg">
                Create Your Account <ArrowRight size={18} />
              </a>
              <a href={LOGIN_URL} className="btn btn-outline btn-lg">
                Member Login
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
